import script from "./Cemeteries.vue?vue&type=script&setup=true&lang=js"
export * from "./Cemeteries.vue?vue&type=script&setup=true&lang=js"

import "./Cemeteries.vue?vue&type=style&index=0&id=f2b95ec4&scoped=true&lang=css"
import "./Cemeteries.vue?vue&type=style&index=1&id=f2b95ec4&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2b95ec4"]])

export default __exports__